import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=9489710e"
import script from "./Contacts.vue?vue&type=script&setup=true&lang=js"
export * from "./Contacts.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports